export function convertStringValuesToBoolean(_key: string, value: string) {
  if (value === 'true' || value === 'false') {
    return value === 'true';
  }
  return value;
}
